<template>
  <v-card>
    <v-row>
      <v-col cols="12" md="4" class="mr-n1">
        <v-row>
          <v-col cols="auto">
            <v-card-text class="py-0">
              <user-avatar
                :size="80"
                :user="user"
                color="performance"
                borderColor="performance"
                cssClass="text-h3"
                textColor="white"
              ></user-avatar>
            </v-card-text>
          </v-col>
          <v-col>
            <v-card-title>{{ user.fullName }}</v-card-title>
            <v-card-subtitle>{{ user.jobTitle }}</v-card-subtitle>
          </v-col>
        </v-row>
      </v-col>
      <v-divider vertical v-if="$vuetify.breakpoint.mdAndUp"></v-divider>
      <v-col
        cols="12"
        md="8"
        :class="$vuetify.breakpoint.mdAndUp ? 'mr-n1 pl-0 pr-2' : ''"
      >
        <v-divider v-if="!$vuetify.breakpoint.mdAndUp"></v-divider>
        <div v-for="(review, i) in reviews(user.id)" :key="review.id">
          <v-row>
            <v-col cols="12" class="pl-8 pr-8">
              <div class="subtitle-1 font-weight-bold secondarytext--text pb-4">
                {{ review.question }}
              </div>
              <div class="d-flex flex-wrap">
                <rating
                  class="mr-2"
                  v-model="review.answer"
                  v-on:change="saveAnswer(review.id, $event)"
                  v-if="showRating(review)"
                  :disabled="disabled && review.completeDate != null"
                ></rating>
                <v-btn
                  height="40"
                  :dark="has_answer_text(review)"
                  :outlined="!has_answer_text(review)"
                  elevation="0"
                  class="mr-2"
                  @click="
                    !disabled || review.completeDate == null
                      ? showTextAnswer(review)
                      : null
                  "
                  :color="has_answer_text(review) ? 'secondary' : 'lighttext'"
                  v-else
                >
                  Write Response
                </v-btn>
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      height="40"
                      :dark="not_applicable(review)"
                      :outlined="!not_applicable(review)"
                      elevation="0"
                      class="mr-2"
                      @click="
                        !disabled || review.completeDate == null
                          ? saveAnswer(review.id, null)
                          : null
                      "
                      :color="
                        not_applicable(review) ? 'secondary' : 'lighttext'
                      "
                      v-bind="attrs"
                      v-on="on"
                    >
                      NA
                    </v-btn>
                  </template>
                  <span class="pa-2">Not Applicable</span>
                </v-tooltip>
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      :outlined="!review.feedback"
                      height="40"
                      :color="review.feedback ? 'secondary' : 'lighttext'"
                      @click="
                        !disabled || review.completeDate == null
                          ? showFeedback(review)
                          : null
                      "
                      v-if="showRating(review)"
                      v-bind="attrs"
                      v-on="on"
                    >
                      <v-icon>message</v-icon>
                    </v-btn>
                  </template>
                  <span class="pa-2">Leave Feedback</span>
                </v-tooltip>
              </div>
            </v-col>
          </v-row>
          <v-divider v-if="i < reviews(user.id).length - 1"></v-divider>
        </div>
      </v-col>
    </v-row>
    <edit-review-feedback-dialog
      ref="editFeedback"
      v-on:save="saveFeedback"
    ></edit-review-feedback-dialog>
    <edit-review-text-dialog
      ref="editText"
      v-on:save="saveAnswerText"
    ></edit-review-text-dialog>
  </v-card>
</template>

<script>
import { mapGetters } from "vuex";
import Rating from "@/components/common/Rating";
import EditReviewFeedbackDialog from "@/components/reviews/EditReviewFeedbackDialog";
import EditReviewTextDialog from "@/components/reviews/EditReviewTextDialog";
export default {
  name: "ReviewCard",
  props: {
    user: { type: Object },
    allReviews: { type: Array },
    disabled: { type: Boolean, default: false }
  },
  components: { Rating, EditReviewFeedbackDialog, EditReviewTextDialog },
  data: () => ({}),
  watch: {},
  computed: {
    userId() {
      return this.user.id;
    },
    showRating() {
      return review => {
        return this.$enums.questionTypes.OPINION_SCALE == review.questionTypeId;
      };
    },
    reviews() {
      return userId => {
        return this.allReviews.filter(x => x.user.id == userId);
      };
    },
    not_applicable() {
      return review => {
        return (
          review.answer == null &&
          review.answerText == null &&
          review.completeDate
        );
      };
    },
    has_answer_text() {
      return review => {
        return (
          (review.answerText || "").length > 0 && review.completeDate != null
        );
      };
    },
    ...mapGetters({ profile: "profile/profile" })
  },
  created() {},
  methods: {
    saveAnswer(id, answer) {
      this.$store
        .dispatch("review/saveReviewAnswer", { id, answer })
        .then(() => {
          this.$root.$snackbarSuccess("Answer saved");
        })
        .catch(error => {
          this.logError(error);
          this.$root.$alert(
            "Error Occurred",
            "An error occured while saving your review."
          );
        });
    },
    saveAnswerText(answer) {
      this.$store
        .dispatch("review/saveReviewAnswer", answer)
        .then(() => {
          this.$root.$snackbarSuccess("Answer saved");
        })
        .catch(error => {
          this.logError(error);
          this.$root.$alert(
            "Error Occurred",
            "An error occured while saving your review."
          );
        });
    },
    showFeedback(review) {
      this.$refs.editFeedback.showDialog(review);
    },
    showTextAnswer(review) {
      this.$refs.editText.showDialog(review);
    },
    saveFeedback(review) {
      this.$store
        .dispatch("review/saveReviewFeedback", {
          id: review.id,
          feedback: review.feedback
        })
        .then(() => {
          this.$root.$snackbarSuccess("Feedback saved");
        })
        .catch(error => {
          this.logError(error);
          this.$root.$alert(
            "Error Occurred",
            "An error occured while saving your review."
          );
        });
    }
  }
};
</script>
